export const redCards = [
  "takes off [2] shoes and socks during flight",
  "reminds the teacher about assigning homework",
  "acts like the boss as an entry-level employee",
  "steals roommate's food, then denies involvement",
  "backs up without looking",
  "drives like [6] wearing a blindfold",
  "breaks up with [2] partner of three years via text message",
  "always texts in voice messages",
  "smokes to seem cool",
  "is incapable of having a conversation with someone [8] not find attractive",
  "gets drunk, throws up, says [6] never drinking again, and goes out the following weekend",
  "tries to get with people who are in relationships",
  "tells [2] friends to break up with their partners no matter the situation",
  "steals all the blankets at night",
  "makes jokes about people's insecurities",
  "says \"Almost there\" and hasn't even left the house",
  "thinks washing [2] hands after using the restroom is optional",
  "eats groceries before purchasing them at the grocery store",
  "always thinks [2] problems are worse than everyone else's",
  "only goes to the gym for workout pictures and barely works out",
  "thinks that [2] music taste is superior",
  "gives unsolicited advice",
  "insults the other person instead of presenting a logical argument",
  "switches lanes without looking",
  "borrows things and never returns them",
  "refuses to wear a condom because it \"doesn't feel as good\"",
  "overpromises and underdelivers in bed",
  "farts in the elevator and walks out, making others bask in the smell",
  "uses the rest of the toilet paper, doesn't replace it or tell anyone, and lets the next person suffer",
  "creates a secret social media account to start fights in comments",
  "is a little bitch",
  "thinks [2] partner should read [2] mind",
  "doesn't know how to give head and refuses constructive criticism",
  "thinks women do not need to finish",
  "always receives head and never reciprocates",
  "drops all [2] friends as soon as [9] a partner",
  "always complains about [2] partner but refuses to break up with them",
  "tries to cheat on [2] partner but keeps getting rejected",
  "makes out with [2] partner in public",
  "picks [2] nose, then eats it",
  "posts an entire concert on social media while singing along",
  "gaslights [2] partner when [6] in the wrong",
  "crop dusts an unsuspecting old lady",
  "likes and comments on models' social media posts while having a partner",
  "says all [2] exes are crazy while being the crazy one",
  "makes way too much eye contact",
  "stares only at women's breast",
  "cannot be in silence for more than 2 minutes",
  "brings up past arguments instead of admitting fault in the current one",
  "rages when [2] sports team loses",
  "plays music out loud in a public setting",
  "sits in study spots and argues on a video call the whole time",
  "wears sandals and jeans to the gym",
  "gets naked to take a shit",
  "says \"You too\" when the worker tells [3] to enjoy [2] food",
  "acts like choosing where to eat is a calculus problem",
  "says \"Time for you to get a watch\" when someone asks what time it is",
  "presses the already lit elevator button \"just to be sure\"",
  "always asks for advice from friends and then does the exact opposite",
  "hits the curb every time [10]",
  "takes 3-5 business days to respond to a text",
  "finishes in 10 seconds and asks if she finished too",
  "genuinely believes the Earth is flat",
  "insists [7] a significant other, but no one has ever met them",
  "burns everything [11]",
  "hasn't changed [2] sheets in a year",
  "promises to have just one drink, but always blacks out",
  "has no social awareness",
  "thinks yellow lights mean to speed up",
  "starts preparing for Christmas in July",
  "is allergic to commitment",
  "fills the water cup at restaurants with soda",
  "is the problem family member at Thanksgiving",
  "is a walking red flag",
  "thinks uninterested people are playing hard to get",
  "likes feet a little too much",
  "has mommy issues",
  "thinks [2] partner using toys is cheating",
  "says [2] ex's name while having sex with partner",
  "thinks foreplay is a waste of time",
  "thinks ass is more important than personality",
  "lies about how big [2] penis is",
  "tells three different people \"We are exclusive\"",
  "picks men based on their zodiac sign",
  "catfishes men online",
  "kisses with [2] eyes open",
  "uses way too much tongue",
  "thinks [6] a dating coach but has never been in a relationship",
  "has anger issues",
  "laughs at women's jokes just to get laid",
  "needs a map to locate the clit",
  "takes a bad situation and somehow always makes it worse",
  "answers in riddles to sound smart",
  "likes [2] own posts on social media",
  "points out the obvious",
  "always makes new friends and forgets the old ones",
  "stands way too close to others for no reason",
  "says [7] only been with 3 people, but [7] a roster",
  "just lays there like a dead fish during sex",
  "takes 45-minute shits",
];